import { render, staticRenderFns } from "./sidebarEdu.vue?vue&type=template&id=bac3f1b0&"
import script from "./sidebarEdu.vue?vue&type=script&lang=js&"
export * from "./sidebarEdu.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/fontFace.css?vue&type=style&index=0&lang=css&"
import style1 from "./sidebarEdu.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports